import { classnames } from '@tailwindcss-classnames';

const bgWhite = classnames('bg-white');
const bgGrey800 = classnames('bg-nzxt-dark-grey-800');
const textWhite = classnames('text-white');
const textLightGrey500 = classnames('text-nzxt-light-grey-600');
const textLightGrey800 = classnames('text-nzxt-light-grey-800');

export const relative = classnames('relative');
export const container = classnames('ml-3', relative);
export const flexCenter = classnames('flex', 'items-center');
export const legalText = classnames('text-xs', 'px-6');
export const textCenter = classnames('text-center');

export const forgotLinksBase = classnames('pl-0', 'pr-0', 'text-sm');

const whiteLogo = classnames(textWhite, 'fill-current');
export const logo = (isInverted?: boolean): string =>
  classnames('w-20', 'h-6', 'mx-auto', {
    [whiteLogo]: isInverted,
  });

export const forgotWrapper = (isInverted?: boolean): string =>
  classnames(
    'flex',
    'flex-col',
    'justify-center',
    'py-8',
    'sm:px-6',
    'lg:px-8',
    {
      [bgGrey800]: isInverted,
      [bgWhite]: !isInverted,
    }
  );

export const standaloneWrapper = (isInverted?: boolean): string =>
  classnames(
    'm-auto',
    'max-w-lg',
    'lg:py-12',
    'flex',
    'flex-col',
    'justify-center',
    'py-8',
    'sm:px-6',
    'lg:px-8',
    {
      [bgGrey800]: isInverted,
      [bgWhite]: !isInverted,
    }
  );

export const forgotTopCard = classnames(
  'sm:mx-auto',
  'sm:w-full',
  'sm:max-w-md'
);

export const forgotHeadingWrapper = classnames('px-4', 'sm:px-10');

export const forgotHeading = (isInverted?: boolean): string =>
  classnames('mt-6', 'text-center', 'text-3xl', 'font-extrabold', {
    [textWhite]: isInverted,
    [textLightGrey800]: !isInverted,
  });

export const forgotSubheading = (isInverted?: boolean): string =>
  classnames('text-center', 'text-sm', 'mx-auto', 'mt-4', 'px-4', {
    [textWhite]: isInverted,
    [textLightGrey500]: !isInverted,
  });

export const forgotBottomCard = classnames(
  'sm:mx-auto',
  'sm:w-full',
  'sm:max-w-md'
);
export const forgotFormWrapper = classnames('pt-4', 'md:pt-8', 'sm:px-10');
export const forgotForm = classnames('space-y-6');
export const forgotButton = classnames('mx-auto', 'w-full');
export const forgotSignUpWrapper = classnames(
  'mt-4',
  'flex',
  'items-center',
  'justify-center'
);
export const forgotSignUpText = classnames('text-center');

export const notificationWrapper = classnames('p-3', 'rounded-md', 'mb-8');

export const errorWrapper = classnames(notificationWrapper, 'bg-error');
export const successWrapper = classnames(notificationWrapper, 'bg-green-500');

export const notification = classnames(
  'text-white',
  'text-sm',
  'font-semibold'
);
